export default __webpack_public_path__ + "static/media/close.8c438afc.svg";